import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M10.3828 7H32.9982\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21Z\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M3 18H14.3077\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M21.6924 18H33.0001\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M29 32C30.6569 32 32 30.6569 32 29C32 27.3431 30.6569 26 29 26C27.3431 26 26 27.3431 26 29C26 30.6569 27.3431 32 29 32Z\" stroke=\"#121926\" stroke-width=\"2\"></path><path d=\"M25.6154 29H3\" stroke=\"#121926\" stroke-width=\"2\"></path>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_9]))
}
export default { render: render }